
<template>

    <!-- Modal -->
    <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static"
        data-bs-keyboard="false" tabindex="-1">

        <div class="modal-dialog">
            <div class="modal-content">

                <div class="modal-header">
                    <h1 class="modal-title fs-5">Rol</h1>

                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        @click="cerrar()"
                    ></button>
                </div>

                <div class="modal-body">

                    <div class="py-1 row">
                        <div class="col-md-3">
                            <label>Nombre <span class="is-invalid">*</span></label>
                        </div>

                        <div class="col-md-9">
                            <input
                                class="form-control"
                                type="text"
                                v-model="datosRol.name"
                            />

                            <label class="is-invalid">
                                {{ validation.name }}
                            </label>
                        </div>
                    </div>

                </div>

                <div class="modal-footer">

                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                        ref="botonObjetivo"
                        @click="cerrar()"
                    >
                        Cancelar
                    </button>

                    <button
                        v-if="modalAlta == false"
                        type="button"
                        class="btn"
                        style="background-color:#F49315;color:white;"
                        @click="actualizarRol"
                    >
                        Actualizar
                    </button>

                    <button
                        v-else
                        type="button"
                        class="btn"
                        style="background-color:#F49315;color:white;"
                        @click="altaRol"
                    >
                        Guardar
                    </button>

                </div>

            </div>
        </div>
    </div>

    <!-- Titulo -->
    <div class="col-md-12">

        <h4 class="mb-sm-0" style="text-align: left;">Roles</h4>

        <br>

        <div class="py-1 row">
            <div class="col-md-1">
                <button
                    type="button"
                    class="btn"
                    style="background-color:#F49315;color:white;"
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                    @click="registrarRol"
                >
                    Registrar
                </button>
            </div>
        </div>

    </div>

    <!-- Busqueda -->
    <!--<div class="col-md-6">

        <span>Buscar Columna:</span>

        <select class="form-control" v-model="searchField">
            <option value="name">Nombre</option>
        </select>

        <br>

        <span>Buscar:</span>

        <input
            type="text"
            class="form-control"
            v-model="searchValue"
        >

    </div>-->
    <div class="row">
        <div class="col-md-4">
            <label class="form-label">Buscar Columna:</label>
            <select class="form-control" v-model="searchField">
                <option value="name">Nombre</option>
            </select>
        </div>

        <div class="col-md-4">
            <label class="form-label">Buscar:</label>
            <input
                type="text"
                class="form-control"
                v-model="searchValue"
            >
        </div>
    </div>
    <br>

    <EasyDataTable
        :headers="headers"
        :items="roles"
        :search-field="searchField"
        :search-value="searchValue"
    >

        <template #item-operation="item">
            <!--<button
                class="fa fa-eye btn-success"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop"
                @click="showRow(item)"
            ></button>

            &nbsp;

            <button
                class="fa fa-trash btn-danger"
                @click="eliminarRol(item.id)"
            ></button>-->
             <button class="btn btn-light btn-sm" type="button" @click="showRow(item)"
            data-bs-toggle="modal"
                data-bs-target="#staticBackdrop"
                ><span class="fa fa-eye" style="color:#F49315;"></span></button>
            <!--<button class="fa fa-trash btn-danger" type="button" data-bs-toggle="modal" data-bs-target="#staticBackdrop" @click="eliminarRol(item.id)"></button>-->
             <button class="btn btn-light btn-sm" type="button" @click="eliminarRol(item)"
           
                ><span class="fa fa-trash" style="color:red;"></span></button>
        </template>

    </EasyDataTable>

</template>

<script>

import "vue3-easy-data-table/dist/style.css";
import axios from "axios";
import Swal from "sweetalert2";

//var url = "https://backsarei.seguridadeninspeccion.com/api";
//var url = "http://127.0.0.1:8000/api";


export default {

    data() {

        return {

            searchField: [],
            searchValue: [],

            roles: [],
            headers: [],

            datosRol: {
                id: "",
                name: ""
            },

            validation: {
                name: ""
            },

            modalAlta: false

        }

    },

    created() {
        this.consultarRoles();
    },

    methods: {

        registrarRol() {
            this.modalAlta = true;
            this.cerrar();
        },

        cerrar() {

            this.datosRol = {
                id: "",
                name: ""
            };

            this.validation.name = "";

        },

        consultarRoles() {

            const token = localStorage.getItem("accessToken");

            axios.get(this.$rutaServer + "catalogo-roles", {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            .then(response => {

                this.roles = response.data;

                this.headers = [
                    { text: "ID", value: "id" },
                    { text: "Nombre", value: "name" },
                    { text: "Operación", value: "operation" }
                ];

                this.searchField = ["name"];

            });

        },

        altaRol() {

            const token = localStorage.getItem("accessToken");

            axios.post(
                this.$rutaServer + "catalogo-roles",
                {
                    name: this.datosRol.name
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            )
            .then(() => {

                Swal.fire(
                    "Éxito",
                    "Rol registrado correctamente",
                    "success"
                );

                this.consultarRoles();
                this.$refs.botonObjetivo.click();

            });

        },

        showRow(item) {

            this.modalAlta = false;

            this.datosRol.id = item.id;
            this.datosRol.name = item.name;

        },

        actualizarRol() {

            const token = localStorage.getItem("accessToken");

            axios.put(
                this.$rutaServer + "catalogo-roles/" + this.datosRol.id,
                {
                    name: this.datosRol.name
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            )
            .then(() => {

                Swal.fire(
                    "Éxito",
                    "Rol actualizado correctamente",
                    "success"
                );

                this.consultarRoles();
                this.$refs.botonObjetivo.click();

            });

        },

        eliminarRol(id) {

            Swal.fire({
                title: "¿Eliminar rol?",
                icon: "warning",
                showCancelButton: true
            }).then((result) => {

                if (!result.isConfirmed) return;

                const token = localStorage.getItem("accessToken");

                axios.delete(
                    this.$rutaServer + "catalogo-roles/" + id,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                )
                .then(() => {

                    Swal.fire(
                        "Éxito",
                        "Rol eliminado",
                        "success"
                    );

                    this.consultarRoles();

                });

            });

        }

    },

    components: {
        EasyDataTable: window["vue3-easy-data-table"]
    }

}

</script>
